goog.provide('el8.util.format');

goog.require('el8.template.util.format');

el8.util.format = function(text, formatting) {

    /**
     * Expect formatting to be a list 
     * [
     *     {'decoration': <name>, 'offsets': [X, Y]}, ...
     *     {'decoration': <name>, 'offsets': [X, Y]}, ...
     * ]
     * that is sorted in order of offsets (i.e. item appearing 
     * earlier in the list applies to earlier in the string 
     * (lower offsets)
     */

    return el8.template.util.format.apply({
        text: text,
        formatting: formatting
    }).el8_unescape();

};

